define("settings/templates/groups/group/members/new", ["exports", "@ember/template-factory"], function (_exports, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars"eaimeta@70e063a35619d71f
  var _default = _exports.default = (0, _templateFactory.createTemplateFactory)(
  /*
    <Shared::Modal @close={{action (perform this.handleClose)}} as |modal|>
    <modal.card @portrait={{true}}>
      <modal.card-header @title={{t "account.groups.group.users.new.title" name=this.group.name}} />
      <modal.card-body>
        <div class="u--row">
          {{#each this.possibleTeamMembers as |user|}}
            <Cluster::NewTeamMember
              @createMember={{action (perform this.createMember this.group user)}}
              @group={{this.group}}
              @member={{user}}
            />
          {{else}}
            <p class="u--text--md u--text--light">
              {{t "account.groups.group.users.new.empty" name=this.group.name}}
            </p>
          {{/each}}
        </div>
      </modal.card-body>
      <modal.card-footer>
        <div class="o--btnBar u--float--right">
          <Shared::Ui::Button @onClick={{modal.close}} @text={{t "shared_words.close"}} @variant="outline" />
        </div>
      </modal.card-footer>
    </modal.card>
  </Shared::Modal>
  */
  {
    "id": "rmOFJaoN",
    "block": "[[[8,[39,0],null,[[\"@close\"],[[28,[37,1],[[30,0],[28,[37,2],[[30,0,[\"handleClose\"]]],null]],null]]],[[\"default\"],[[[[1,\"\\n  \"],[8,[30,1,[\"card\"]],null,[[\"@portrait\"],[true]],[[\"default\"],[[[[1,\"\\n    \"],[8,[30,1,[\"card-header\"]],null,[[\"@title\"],[[28,[37,3],[\"account.groups.group.users.new.title\"],[[\"name\"],[[30,0,[\"group\",\"name\"]]]]]]],null],[1,\"\\n    \"],[8,[30,1,[\"card-body\"]],null,null,[[\"default\"],[[[[1,\"\\n      \"],[10,0],[14,0,\"u--row\"],[12],[1,\"\\n\"],[42,[28,[37,5],[[28,[37,5],[[30,0,[\"possibleTeamMembers\"]]],null]],null],null,[[[1,\"          \"],[8,[39,6],null,[[\"@createMember\",\"@group\",\"@member\"],[[28,[37,1],[[30,0],[28,[37,2],[[30,0,[\"createMember\"]],[30,0,[\"group\"]],[30,2]],null]],null],[30,0,[\"group\"]],[30,2]]],null],[1,\"\\n\"]],[2]],[[[1,\"          \"],[10,2],[14,0,\"u--text--md u--text--light\"],[12],[1,\"\\n            \"],[1,[28,[35,3],[\"account.groups.group.users.new.empty\"],[[\"name\"],[[30,0,[\"group\",\"name\"]]]]]],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]]],[1,\"      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n    \"],[8,[30,1,[\"card-footer\"]],null,null,[[\"default\"],[[[[1,\"\\n      \"],[10,0],[14,0,\"o--btnBar u--float--right\"],[12],[1,\"\\n        \"],[8,[39,7],null,[[\"@onClick\",\"@text\",\"@variant\"],[[30,1,[\"close\"]],[28,[37,3],[\"shared_words.close\"],null],\"outline\"]],null],[1,\"\\n      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[1]]]]]],[\"modal\",\"user\"],false,[\"shared/modal\",\"action\",\"perform\",\"t\",\"each\",\"-track-array\",\"cluster/new-team-member\",\"shared/ui/button\"]]",
    "moduleName": "settings/templates/groups/group/members/new.hbs",
    "isStrictMode": false
  });
});